<template>
  <mf-loading-dialog :loading="loadingData">
    <v-dialog :value="value" max-width="600px" persistent @click:outside="closeDialog">
      <v-card>
        <v-card-title class="pb-0">
          <span class="table-card-title">Confira o que encontramos:</span> <br />
          <p class="subtitle ma-0" style="word-break: break-word">Aqui você aprova ou não as ações que conseguimos identificar</p>
        </v-card-title>
        <v-card-text class="px-0">
          <v-row class="mx-4">
            <v-col>
              <v-alert v-if="failures.failureLinesQuantity > 0" dense color="#fac1b6">
                <mf-icon fill color="vermelho-0" class="mr-2">warning</mf-icon>
                <span class="error-message">
                  {{ errorMesage }}
                  <a class="custom-link" @click="exportFailureGroups"> Clique aqui para exportar</a>
                </span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="pa-0">
              <v-data-table :items="actions" :headers="headers" disable-filtering disable-pagination disable-sort hide-default-footer>
                <template v-slot:item="{ item }">
                  <tr class="texto-corrido">
                    <td>{{ item.action }}</td>
                    <td class="text-right pr-10">{{ item.quantity }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <mf-action-buttons
            class="px-3"
            :primary-button="{
              text: 'Aprovar',
              action: confirmUpsert,
              isVisible: true,
              isDisabled: !checkForChangesToAprove,
              isLoading: loading,
            }"
            :extra-button="{
              text: 'Cancelar',
              action: closeDialog,
              isVisible: true,
              isLoading: loading,
            }"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </mf-loading-dialog>
</template>

<script>
import { createCsvFromArray } from '@/config/helpers.js'
import { CONFIRM_PRODUCTS_GROUPS_BULK_UPSERT } from '../../graphql'

const parseError = {
  BULK_PRODUCT_GROUPS_MISSING_FIELDS: 'Informação faltante',
  BULK_PRODUCT_GROUPS_INVALID_NAME: 'Nome do grupo inválido',
  BULK_PRODUCT_GROUPS_UNFOUND_PRODUCT: 'Produto não encontrado',
}

export default {
  name: 'ConferirImportacaoGrupos',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    loadingData: {
      type: Boolean,
    },
    updatePreexisting: {
      type: Boolean,
      required: true,
    },
    dataFileUrl: {
      type: String,
      required: true,
    },
    failures: {
      type: Object,
      required: true,
    },
    actions: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Ação',
          value: 'action',
          align: 'left',
          class: 'pl-6',
        },
        {
          text: 'Quantidade',
          value: 'quantity',
          align: 'right',
          class: 'pr-9',
        },
      ]
    },
    checkForChangesToAprove() {
      return !!this.actions.filter((action) => action.quantity > 0).length
    },
    errorMesage() {
      const failureQty = this.failures.failureLinesQuantity || 0
      let errorText

      if (this.failures.failureLinesQuantity <= 1) {
        errorText = `Foi encontrada ${failureQty} linha com erro.`
      } else {
        errorText = `Foram encontradas ${failureQty} linhas com erro.`
      }

      return errorText
    },
  },
  methods: {
    closeDialog() {
      this.$emit('input', false)
      this.$emit('resetSettings')
      this.$bus.$emit('update', true)
    },
    exportFailureGroups() {
      createCsvFromArray(
        this.failures.failureLines.map((group) => {
          const { reason, ean, sku, name } = group

          if (!ean) {
            return { name, sku, reason: parseError[reason] }
          }
          return { name, ean, reason: parseError[reason] }
        }),
        'produtos com falha',
        ['nome', 'sku/ean', 'erro']
      )
    },
    confirmUpsert() {
      try {
        this.loading = true
        this.$apollo
          .mutate({
            mutation: CONFIRM_PRODUCTS_GROUPS_BULK_UPSERT,
            variables: {
              dataFileURL: this.dataFileUrl,
              updatePreexisting: this.updatePreexisting,
            },
            context: {
              uri: this.$microservicesUrls['upload'],
            },
          })
          .then(() => {
            this.$snackbar({ message: 'Edições realizadas com sucesso! Você já pode conferir os grupos criados na plataforma.', snackbarColor: 'success' })
            this.loading = false
            this.closeDialog()
          })
      } catch (e) {
        console.log(e)
        this.$snackbar({ message: 'Falha ao aprovar importação de arquivo.' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-link {
  color: $vermelho-0 !important;
  font-size: 16px;
  text-decoration: underline;
}
.error-message {
  color: $vermelho-0;
}
</style>
